import { Language, ListStyle } from '@yleisradio/areena-types';
import { CardList } from '../View/viewTypes';

export type GroupType = 'list' | 'grid' | 'highlight_card';
export type ListStyleSize = ListStyle['size'] | undefined;
export type ListStyleLayout = ListStyle['layout'] | undefined;

export const getGroupType = (
  contentType: CardList['listType'],
  listStyle: CardList['style']
): GroupType => {
  if (listStyle?.layout === 'grid') {
    return 'grid';
  }
  if (contentType === 'highlightCard') {
    return 'highlight_card';
  }
  if (contentType === 'list') {
    return 'list';
  }

  console.warn(
    `Unknown mapping to snowplow groupType from content.type: ${contentType} and listStyle.layout: ${listStyle?.layout}`
  );
  return 'list';
};

export const uiLanguageToSnowplowLanguage = (
  language: Language
): 'fin' | 'swe' => {
  switch (language) {
    case 'fi':
      return 'fin';
    case 'sv':
      return 'swe';
    default:
      throw new Error(`Unsupported language: ${language}`);
  }
};
